export default __webpack_public_path__ + "static/user2-ab0ebb7ace2800f64ec118d0638f487f.jpg";